export { default } from './Socials'
